module.exports = __webpack_public_path__ + "img/744.c640f983.jpg";